<template>
  <div>
    <print-img :prescriptionImg="printImg" class="is-print-show"></print-img>
    <div class="is-print-hide">
      <el-table
        stripe
        :data="List"
        row-key="id"
        size="medium"
        header-row-class-name="common-table-header"
        row-class-name="common-table-row"
        class="is-print-hide common-table"
        :border="true"
      >
        <el-table-column prop="storeNo" label="门店编号" min-width="107">
          <template slot="header" slot-scope="scope">
            <div class="hname">门店编号</div>
          </template>
          <template slot-scope="scope">
            <div class="storeNo_box">
              <div class="tag" v-if="scope.row.disableStatus == 1">
                <img :src="require('@/assets/img/disabledTag.png')" alt="" />
              </div>
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.storeNo" placement="top">
                <span>{{ scope.row.storeNo }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="门店名称" min-width="263">
          <template slot-scope="scope">
            <div class="storename_cell">
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.name" placement="top">
                <span class="store-name">
                  {{ scope.row.name }}
                </span>
              </el-tooltip>
              <template v-if="scope.row.serviceTypes">
                <div class="tags-container">
                  <span class="name-tag" v-for="(type, index) in scope.row.serviceTypes" :key="index">
                    {{ type }}
                  </span>
                </div>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="所属公司" min-width="163" v-if="$checkPower('h,i,j')">
          <span slot-scope="scope">{{ scope.row.companyName }}</span>
        </el-table-column>
        <el-table-column prop="shopManager" label="店长" min-width="66">
          <template slot-scope="scope">
            <div class="over_ell">
              <el-tooltip
                class="item"
                effect="dark"
                :open-delay="500"
                :content="
                  (scope.row.shopManager && scope.row.shopManager.name) ||
                  (scope.row.shopManager && scope.row.shopManager.mobile)
                "
                placement="top"
              >
                <span v-if="scope.row.shopManager">{{ genshopManager(scope.row.shopManager) }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="prescriptionAuditorName" min-width="220" v-if="!superviseRole">
          <template slot="header" slot-scope="scope" :row-key="scope.row.id">
            <div class="table_header">
              <headerChecBox type="1" :List="List"></headerChecBox>
              <span @click="test" class="table_header_text">是否审方 / 远程审方药师</span>
            </div>
          </template>

          <template slot-scope="scope">
            <div class="remotePharmacistRow">
              <div class="row_check">
                <popCheckbox :listData="scope" type="1"></popCheckbox>
              </div>
              <div class="row_tex over_ell">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :open-delay="500"
                  :content="GendrugstorePharmacist(scope.row.remotePharmacist)"
                  placement="top"
                >
                  <span>
                    {{ GendrugstorePharmacist(scope.row.remotePharmacist) }}
                  </span>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="relation" min-width="220" v-if="!superviseRole">
          <template slot="header" slot-scope="scope">
            <div class="table_header">
              <headerChecBox type="2" :List="List"></headerChecBox>
              <span class="table_header_text">是否审方 / 驻店审方药师</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="remotePharmacistRow">
              <div class="row_check">
                <popCheckbox :listData="scope" :List="List" type="2"></popCheckbox>
              </div>
              <div class="row_tex over_ell">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :open-delay="500"
                  :content="GendrugstorePharmacist(scope.row.drugstorePharmacist)"
                  placement="top"
                >
                  <span>
                    {{ GendrugstorePharmacist(scope.row.drugstorePharmacist) }}
                  </span>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column v-if="userInfo && userInfo.isHaveLocalPrescriptions" min-width="246">
          <template slot="header" slot-scope="scope" :row-key="scope.row.id">
            <div class="table_header">
              <headerChecBox type="7" :List="List"></headerChecBox>
              <span class="table_header_text">是否对接当前审方中心</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="remotePharmacistRow">
              <div class="row_check">
                <popCheckbox :listData="scope" type="7"></popCheckbox>
              </div>
              <div class="row_tex over_ell" v-if="scope.row.localPrescriptions">
                <span v-if="mode == '1'">
                  {{ getLPCnameById(scope.row.localPrescriptionsCenter, scope.row.localPrescriptions) }}
                </span>
                <SourceSelect :row="scope.row" v-else />
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="dispenseStatus" label="调配" v-if="$checkPower('a,c,d')">
          <template #header>
            <div class="table_header">
              <headerChecBox type="4" :List="List" />
              <span class="table_header_text">调配</span>
            </div>
          </template>
          <template #default="scope">
            <popCheckbox :listData="scope" type="4" />
          </template>
        </el-table-column>
        <el-table-column prop="dispatchStatus" label="发药" v-if="$checkPower('a,c,d')">
          <template #header>
            <div class="table_header">
              <headerChecBox type="5" :List="List" />
              <span class="table_header_text">发药</span>
            </div>
          </template>
          <template #default="scope">
            <popCheckbox :listData="scope" type="5" />
          </template>
        </el-table-column>
        <el-table-column prop="status" min-width="120" v-if="$checkPower('a,c,d')">
          <template slot="header" slot-scope="scope">
            <div class="table_header">
              <headerChecBox type="3" :List="List"></headerChecBox>
              <span class="table_header_text">人脸识别</span>
            </div>
          </template>
          <template slot-scope="scope">
            <popCheckbox :listData="scope" type="3"></popCheckbox>
            <!-- <span>{{ renderText(scope.row.status) }}</span> -->
          </template>
        </el-table-column>

        <el-table-column v-if="diagnoseBeforeAskShow" prop="status" min-width="140">
          <template slot="header" slot-scope="scope">
            <div class="table_header">
              <headerChecBox type="6" :List="List"></headerChecBox>
              <span class="table_header_text">视频先问后诊</span>
            </div>
          </template>
          <template slot-scope="scope">
            <popCheckbox :listData="scope" type="6"></popCheckbox>
          </template>
        </el-table-column>

        <el-table-column prop="status" min-width="140" v-if="$checkPower('a,c,d')">
          <template slot="header" slot-scope="scope">
            <div class="table_header">
              <headerChecBox type="8" :List="List"></headerChecBox>
              <span class="table_header_text">图文问诊</span>
            </div>
          </template>
          <template slot-scope="scope">
            <popCheckbox :listData="scope" type="8"></popCheckbox>
          </template>
        </el-table-column>

        <el-table-column prop="status" label="状态" min-width="80" v-if="$checkPower('a,c,d')">
          <template slot-scope="scope">
            <div>
              <el-tooltip
                class="item"
                effect="dark"
                :open-delay="500"
                :content="renderText(scope.row.status)"
                placement="top"
              >
                <span>{{ renderText(scope.row.status) }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="verifyReason" label="审核理由" min-width="80" v-if="$checkPower('a,c,d')">
          <template slot-scope="scope">
            <div>
              <el-tooltip
                class="item"
                effect="dark"
                :open-delay="500"
                :content="scope.row.verifyReason"
                placement="top"
              >
                <span>{{ scope.row.verifyReason }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" min-width="80">
          <template slot="header" slot-scope="scope">
            <div class="hnamecenter">操作</div>
          </template>
          <template slot-scope="scope">
            <el-row>
              <div class="handler">
                <div class="btn global_common_text_hover" v-if="scope.row.status != -1" @click="showShop(scope.row.id)">
                  <span>查看</span>
                </div>
                <div
                  class="btn global_common_text_hover"
                  v-if="scope.row.status != -1 && $checkPower('a,c,d')"
                  @click="settingShop(scope.row.id, scope.row.prescriptionTemplate, scope.row.forbiddenModifyTemplate)"
                >
                  <span>设置</span>
                </div>
                <div class="btn global_common_text_hover" v-if="editShow(scope)" @click="editorShop(scope.row.id)">
                  <span>编辑</span>
                </div>
                <div class="btn global_common_text_hover" v-if="false" @click="stopShop(scope.row.id)">
                  <span>禁用</span>
                </div>
              </div>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <dataMode :show="dataModeShow"></dataMode> -->
  </div>
</template>

<script>
import printImg from '@/components/printPrescriptionImg';
import { mapGetters, mapState } from 'vuex';
import popCheckbox from '@/components/shopManagement/popCheckbox';
import headerChecBox from '@/components/shopManagement/headerCheckbox';
import SourceSelect from '@/pages/shopManagement/components/SourceSelect';
import { hasPermission } from '@/util';
import Constant from '@/lib/constant';
import { dataDesensitization } from '@fastweb/f2e-utils';

const baseRole = Constant.RoleList;
export default {
  name: 'shopManagementTable',
  props: {
    List: Array,
    default: () => []
  },
  components: {
    printImg,
    // dataMode: noDataMode,
    popCheckbox,
    headerChecBox,
    SourceSelect
  },
  data() {
    return {
      printImg: '',
      pcListConfig: {
        dispense: false,
        dispatch: false
      },
      dataModeShow: false,
      checked: false,
      checkList: ['选中且禁用', '复选框 A'],
      delId: null // 准备禁用ID
    };
  },
  watch: {
    List(value) {
      if (!this.List) {
        return;
      }
      this.dataModeShow = this.List.length == 0;
    }
  },
  activated() {},
  computed: {
    ...mapState('global', ['userInfo']),
    ...mapState('shopManagement', ['mode']),
    ...mapGetters(['superviseRole']),
    ...mapGetters('global', ['allowedConsultTypes']),
    mode() {
      return this.$store.getters.getShopManagementMode;
    },
    diagnoseBeforeAskShow() {
      const manageRole = [baseRole.a, baseRole.c];
      // 如果具备多家药店管理权限的角色，都放开
      if (hasPermission(manageRole)) return true;
      // 店长
      if (hasPermission([baseRole.d])) return this.allowedConsultTypes.allowVideoConsult;
      return false;
    }
  },
  filters: {
    serviceType(val) {
      return Constant.serviceType[val] + '门店';
    }
  },
  methods: {
    // 根据三方审方中心id获取三方审方中心名字
    getLPCnameById(id, list = []) {
      //  【紧急！】 目前只有时空 后续交互会修改
      const re = list.filter(item => item.id === id);
      return re.length ? re[0].name : '';
    },
    stopShop(id) {
      this.delId = id;
      this._can_you_delete_store();
    },
    async _can_you_delete_store() {
      let res = null;
      const storeId = this.delId;
      try {
        let r = await Fetch.can_you_delete_store({ storeId });

        const textObj = {
          1() {
            return {
              title: '禁用药店',
              text: `该药店下<b style="color:#E0514C">仍有分配的职员</b>，禁用后将无法正常登陆。请先在职员管理中修改职员所在门店或删除该职员账号`,
              sure: '忽略并禁用',
              cancle: '取消'
            };
          },
          2() {
            return {
              title: '禁用药店',
              text: `该药店下<b style="color:#E0514C">仍有未处理的处方</b>，禁用后处方将失效`,
              sure: '忽略并禁用',
              cancle: '取消'
            };
          },
          3() {
            return {
              title: '禁用药店',
              text: `该药店下<b style="color:#E0514C">仍有分配的职员</b>，禁用后将无法正常登录。且<b style="color:#E0514C">仍有未处理处方</b>，禁用后处方将失效。`,
              sure: '忽略并禁用',
              cancle: '取消'
            };
          },
          0() {
            return {
              title: '禁用药店',
              text: `确认禁用该药店吗？`,
              sure: '确认',
              cancle: '取消'
            };
          }
        }[r]();
        const _this = this;
        this.$confirm(`${textObj.text}`, `${textObj.title}`, {
          confirmButtonText: `${textObj.sure}`,
          cancelButtonText: `${textObj.cancle}`,
          customClass: 'confirm',
          center: true,
          dangerouslyUseHTMLString: true,
          callback: function (a) {
            if (r == 1) {
              if (a == 'cancel') {
                // 左边按钮
                return;
              }
              if (a == 'confirm') {
                // 右边按钮
                _this._delete_store();

                return;
              }
            }
            if (r == 2) {
              if (a == 'cancel') {
                // 左边按钮

                return;
              }
              if (a == 'confirm') {
                // 右边按钮
                _this._delete_store();
                return;
              }
            }
            if (r == 3) {
              if (a == 'cancel') {
                // 左边按钮

                return;
              }
              if (a == 'confirm') {
                // 右边按钮
                _this._delete_store();
                return;
              }
            }
            if (r == 0) {
              if (a == 'cancel') {
                // 左边按钮

                return;
              }
              if (a == 'confirm') {
                // 右边按钮
                _this._delete_store();
                return;
              }
            }

            console.log(a);
          }
        });

        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },
    async _delete_store() {
      // 删除店铺
      let r = null;
      const storeId = this.delId;
      try {
        r = await Fetch.delete_store({
          storeId
        });
        this.$emit('DelItem', storeId);
      } catch (error) {}
    },

    renderDel() {
      // 渲染删除按钮
      let per = [baseRole.a];
      if (hasPermission(per)) {
        return true;
      } else {
        return false;
      }
    },
    genshopManager(data) {
      // 渲染店长
      if (data.name) {
        return data.name;
      } else {
        if (data.mobile) {
          return dataDesensitization(data.mobile);
        }
        return '';
      }
    },
    editShow(scope) {
      return this.$checkPower('a,c,d') && scope.row.status == -1;
    },
    test() {
      //
      console.log('ttt');
    },
    mode2Show() {
      if (this.mode == 2) {
        return true;
      }
      return false;
    },
    GendrugstorePharmacist(List) {
      // 渲染驻店药师和远程药师 如果说没有名称就显示脱敏手机号
      if (List) {
        return List.map(v => {
          if (v.name) {
            return v.name;
          } else {
            return dataDesensitization(v.mobile);
          }
        }).join(',');
        // return List.join('，');
      }
    },
    renderText(st) {
      // 根据状态渲染文字
      if (st == 0) {
        return '待审核';
      }
      if (st == 1) {
        return '已审核';
      }
      if (st == -1) {
        return '重新认证';
      }
    },
    editorShop(id) {
      this.$router.push('/shopManagement/editorShop/' + id);
    },
    showShop(id) {
      this.$router.push('/shopManagement/showShop/' + id);
    },
    settingShop(id, prescriptionTemplate, forbiddenModifyTemplate) {
      this.$router.push(
        `/shopManagement/settingShop/${id}?prescriptionTemplate=${Number(
          !!prescriptionTemplate
        )}&forbiddenModifyTemplate=${Number(!!forbiddenModifyTemplate)}`
      );
    }
  }
};
</script>

<style lang="scss">
.unselect .el-checkbox {
  // display: none;
}
</style>
<style lang="scss" scoped>
.over_ell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.handler {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  .btn {
    font-size: 12px;
    margin-right: 10px;
    text-align: center;
    cursor: pointer;
    &:nth-last-child(1) {
      margin-right: 0;
    }
  }
}

.addressText {
  width: 241px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.remotePharmacistRow {
  display: flex;
  align-items: center;
  overflow: hidden;
  .row_check {
    float: left;
  }
  .row_tex {
    margin-left: 35px;
    float: left;
    max-width: 100px;
  }
}
.table_header {
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  padding: 0;
  line-height: normal;
  width: 100%;
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  // padding-top: 20px;
  // line-height: 30px;
  .table_header_text {
    float: left;
  }
}

.tag {
  position: absolute;
  left: 0;
  top: 0;
  img {
    display: block;
    width: 44px;
  }
}
.hname {
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  padding-left: 2px;
}
.hnamecenter {
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  text-align: center;
}

.storename_cell {
  position: relative;
  padding: 15px 0;

  .store-name {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
  }

  // 标签容器 - 支持换行
  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: flex-start;
  }

  .name-tag {
    display: inline-block;
    margin: 0; // 移除原来的margin，使用gap代替
    padding: 1px 4px; // 改为与badge-text一样
    font-size: 10px; // 改为与badge-text一样
    font-weight: 700; // 改为与badge-text一样
    line-height: 1.2;
    border-radius: 6px; // 改为与badge-text一样
    border: 1px solid #ffd700; // 改为与badge-text一样
    transition: all 0.2s ease;
    white-space: nowrap;

    // 使用与badge-text一样的样式
    // background: linear-gradient(45deg, #ffd700 0%, #ffc107 50%, #ffb300 100%);
    // background: #ffd700;
    // color: #8b4513;
    // box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
    border: 1px solid #1e8dff;
    background-color: #fff;
    color: #1e8dff;

    &:hover {
      transform: scale(1.2);
    }
  }
}
</style>
